"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CogSolid.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CogSolid = function CogSolid(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 438.53 438.53"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Cog Icon"), _react2.default.createElement("path", {
    className: "cog",
    d: "M436.25 181.44a9 9 0 0 0-6-3.57l-52.25-8a172 172 0 0 0-11.7-28q5.13-7.14 15.41-20.13t14.56-19a11 11 0 0 0 2.28-6.57 9.19 9.19 0 0 0-2-6.28q-10.27-14.52-47.1-48.49a11 11 0 0 0-7.13-2.85 9.27 9.27 0 0 0-6.85 2.57l-40.55 30.54a176.47 176.47 0 0 0-25.69-10.56l-8-52.53A8.47 8.47 0 0 0 258 2.43 10.78 10.78 0 0 0 251 0h-63.43q-8.28 0-10.28 8-3.71 14.27-8.28 53.1a163.37 163.37 0 0 0-26 10.85L103.64 41.4a12.15 12.15 0 0 0-7.42-2.85q-6.28 0-27 20.41T41.11 89.65q-2.57 3.71-2.57 6.57a10.72 10.72 0 0 0 2.85 6.85q19.13 23.13 30.55 39.4a140.79 140.79 0 0 0-11.13 26.26l-53.1 8a8.61 8.61 0 0 0-5.42 3.71A11 11 0 0 0 0 187v63.38a10.78 10.78 0 0 0 2.28 6.71 9 9 0 0 0 6 3.57l52.25 7.71a141 141 0 0 0 11.7 28.26q-5.14 7.14-15.42 20.13t-14.56 19a11 11 0 0 0-2.25 6.56 11.16 11.16 0 0 0 2 6.56q11.13 15.43 47.11 48a9.84 9.84 0 0 0 7.11 3.12 10.27 10.27 0 0 0 7.14-2.56l40.26-30.55a177.1 177.1 0 0 0 25.7 10.57l8 52.53a8.49 8.49 0 0 0 3.28 6.14 10.76 10.76 0 0 0 7 2.42H251q8.3 0 10.29-8 3.71-14.27 8.27-53.1a163 163 0 0 0 26-10.86l39.4 30.84a13.94 13.94 0 0 0 7.42 2.56q6.28 0 26.83-20.27t28.26-30.84a9.53 9.53 0 0 0 2.57-6.56 11 11 0 0 0-2.86-7.14q-20.55-25.13-30.55-39.4a183 183 0 0 0 11.14-26l52.82-8a8.7 8.7 0 0 0 5.71-3.72 11 11 0 0 0 2.28-6.57v-63.35a10.73 10.73 0 0 0-2.33-6.7zm-165.3 89.5q-21.41 21.42-51.68 21.42t-51.68-21.42q-21.41-21.41-21.41-51.67t21.41-51.68q21.42-21.41 51.68-21.41t51.68 21.41q21.41 21.42 21.41 51.68t-21.41 51.67z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CogSolid;